<template>
  <div>
    <Hero />
    <div class="mt-4" v-if="articles">
      <div class="knowledge-list-heading mb-5">
        {{ $t("knowledge.search.terms_example", { terms: $route.query.terms }) }}
      </div>

      <Article
        :article="article"
        v-for="article in articles"
        :key="article.id"
      />
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Hero from "@/components/knowledge/Hero";
import Article from "@/components/knowledge/Article";

export default {
    name: "Search",
    computed: mapGetters({"articles": "knowledge/search/articles"}),
    components: { Hero, Article }
};
</script>

<style>
.bb-view-background {
  background: var(--knowledge-background);
}
</style>
